<app-element-template [element]="element" *ngIf="element.images?.length > 0">
	<app-reference-images [images]="element.images"></app-reference-images>
</app-element-template>
